import './styles.scss'

import { Collapse } from 'antd'

import { ChevronDownIcon, ChevronUpIcon } from '../Icons'

type B2becCollapseProps = React.ComponentProps<typeof Collapse>

const B2becCollapse = (props: B2becCollapseProps) => (
  <Collapse
    {...props}
    className="custom-collapse"
    expandIcon={({ isActive }) => isActive ? <ChevronDownIcon /> : <ChevronUpIcon />}
  />
)

export default B2becCollapse
